import FollowUpTAR from "../../../../src/client/lta-antistolling/FollowUpTAR.js";
import * as React from 'react';
export default {
  FollowUpTAR,
  React
};